import { render, staticRenderFns } from "./storeDataScreen.vue?vue&type=template&id=7203e1c7&scoped=true&"
import script from "./storeDataScreen.vue?vue&type=script&lang=js&"
export * from "./storeDataScreen.vue?vue&type=script&lang=js&"
import style0 from "./storeDataScreen.vue?vue&type=style&index=0&id=7203e1c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203e1c7",
  null
  
)

export default component.exports